/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DesktopLargeBreakpointIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DesktopLargeBreakpointIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 11H4C3.44771 11 3 10.5523 3 10V2C3 1.44772 3.44772 1 4 1H13C13.5523 1 14 1.44772 14 2V10C14 10.5523 13.5523 11 13 11H9V13H11.5V14H5.5V13H8V11ZM4 2H13V10H4L4 2Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DesktopLargeBreakpointIcon.tags = [
  'monitor',
  'tv',
  'computer',
  'display',
  'device',
];

DesktopLargeBreakpointIcon.category = 'General Icons';

DesktopLargeBreakpointIcon.iconSize = 16;
